Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingMoreInfoLabel1926614395",
  {"root":"OfferingMoreInfoLabel1926614395--root","textButtonWrapper":"OfferingMoreInfoLabel1926614395--textButtonWrapper"},
  "",
  8,
  "OfferingMoreInfoLabel1926614395"
);

